<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :fullscreen="!isPC" :close-on-click-modal="false" width="800px" :before-close="handleClose" top="18vh" class="address-dialog" :class="{ 'address-dialog-moblie': !isPC }">
    <el-form v-if="isPC" label-position="top" :rules="rules" label-width="80px" ref="addressForm" :model="addressForm">
      <el-row :gutter="20" class="f-b-c">
        <el-col :span="12">
          <el-form-item :label="$t('address.fullName')" prop="fullName">
            <el-input v-model="addressForm.fullName" :placeholder="$t('common.inputContent')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('address.phoneNumber')" prop="phoneNumber">
            <el-input v-model="addressForm.phoneNumber" :placeholder="$t('common.inputContent')">
              <el-select v-model="areaCode" filterable slot="prepend" style="color:000;width:100px" @change="handleAreaCodeChange">
                <el-option v-for="item in addressDataFilter" :label="item.areaCode" :value="item.countryCode+item.areaCode" :key="item.countryCode+item.areaCode">{{item.areaCode}}({{ item.countryCode }})</el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item :label="$t('address.streetAddressLine1')" prop="streetAddressLine1">
        <el-input v-model="addressForm.streetAddressLine1" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.streetAddressLine2')" prop="streetAddressLine2">
        <el-input v-model="addressForm.streetAddressLine2" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-row :gutter="20" class="f-b-c">
        <el-col :span="12">
          <el-form-item :label="$t('address.countryRegion')" prop="countryCode">
            <el-select v-model="addressForm.countryCode" :placeholder="$t('common.selectContent')" filterable style="width:100%" @change="handleCountryChange" :filter-method="value=> countryFilterMethod(value)">
              <el-option v-for="item in addressDataFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryCode">{{item.countryNameEn}}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('address.stateProviceRegion')" prop="province">
            <!-- <el-select v-if="hasProvice" v-model="addressForm.province" :placeholder="$t('common.selectContent')" filterable style="width:100%">
              <el-option v-for="item in regions" :key="item.id" :label="item.name_en" :value="item.name_en">{{item.name_en}}</el-option>
            </el-select>
            <el-input v-else v-model="addressForm.province" :placeholder="$t('common.inputContent')" style="width:100%"></el-input> -->
            <el-input v-model="addressForm.province" :placeholder="$t('common.inputContent')" style="width:100%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="f-b-c">
        <el-col :span="12">
          <el-form-item :label="$t('address.city')" prop="city">
            <el-input v-model="addressForm.city" :placeholder="$t('common.inputContent')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('address.zipCode')" prop="zipCode">
            <el-input v-model="addressForm.zipCode" :placeholder="$t('common.inputContent')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('address.vat')" prop="vatCode">
            <el-input v-model="addressForm.vatCode" :placeholder="$t('common.inputContent')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="IOSS" prop="ioss">
            <el-input v-model="addressForm.ioss" :placeholder="$t('common.inputContent')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-checkbox v-model="addForm.isDefault" :true-label='1' :false-label='0'>{{$t('address.setAsDefaultAddress')}}</el-checkbox> -->
    </el-form>
    <el-form v-else label-position="top" :rules="rules" label-width="80px" ref="addressForm" :model="addressForm" class="mobile-address-form">
      <el-form-item :label="$t('address.fullName')" prop="fullName">
        <el-input v-model="addressForm.fullName" c:placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.phoneNumber')" prop="phoneNumber">
        <el-input v-model="addressForm.phoneNumber" :placeholder="$t('common.inputContent')">
          <el-select v-model="areaCode" filterable slot="prepend" style="color:000;width:100px" @change="handleAreaCodeChange">
            <el-option v-for="item in addressDataFilter" :label="item.areaCode" :value="item.countryCode+item.areaCode" :key="item.countryCode+item.areaCode">{{item.areaCode}}({{ item.countryCode }})</el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('address.streetAddressLine1')" prop="streetAddressLine1">
        <el-input v-model="addressForm.streetAddressLine1" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.streetAddressLine2')" prop="streetAddressLine2">
        <el-input v-model="addressForm.streetAddressLine2" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.country')" prop="countryCode">
        <el-select v-model="addressForm.countryCode" :placeholder="$t('common.selectContent')" filterable style="width:100%" @change="handleCountryChange" :filter-method="value=> countryFilterMethod(value)">
          <el-option v-for="item in addressDataFilter" :key="item.countryCode" :label="item.countryNameEn" :value="item.countryCode">{{item.countryNameEn}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('address.stateProviceRegion')" prop="province">
        <!-- <el-select v-if="hasProvice" v-model="addressForm.province" :placeholder="$t('common.selectContent')" filterable style="width:100%">
          <el-option v-for="item in regions" :key="item.id" :label="item.name_en" :value="item.name_en">{{item.name_en}}</el-option>
        </el-select>
        <el-input v-else v-model="addressForm.province" :placeholder="$t('common.inputContent')" style="width:100%"></el-input> -->
        <el-input v-model="addressForm.province" :placeholder="$t('common.inputContent')" style="width:100%"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.city')" prop="city">
        <el-input v-model="addressForm.city" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.zipCode')" prop="zipCode">
        <el-input v-model="addressForm.zipCode" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('address.vat')" prop="vatCode">
        <el-input v-model="addressForm.vatCode" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <el-form-item label="IOSS" prop="ioss">
        <el-input v-model="addressForm.ioss" :placeholder="$t('common.inputContent')"></el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="addForm.isDefault" :true-label='1' :false-label='0'>{{$t('address.setAsDefaultAddress')}}</el-checkbox> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="success" :loading="loading" @click="editAddress">{{$t('common.submit')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import areanolist from '@/config/areanolist.js'
import { telephoneNumber, isValidPostalCode, generalPhoneNumber } from '@/util/validate'
let checktelephoneNumber = (rules, value, callback) => {
  // if (telephoneNumber(value)) {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}

export default {
  props: {
    addForm: {
      type: Object,
      default: () => { }
    },
    isOrderAddress: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      areaCode: 'US+1',
      loading: false,
      dialogVisible: false,
      countryList: [],
      hasProvice: true,
      regions: [],
      areanolist: [],
      addressForm: {
        areaCode: '+1'
      },
      rules: {
        fullName: [{ required: true, message: 'Fullname is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        phoneNumber: [{ required: true, message: 'Phone Number is Required', trigger: 'blur' }, { validator: checktelephoneNumber, trigger: 'blur' }, { max: 20, message: 'Please Enter No More Than 20 Characters' }],
        streetAddressLine1: [{ required: true, message: 'Street Address Line is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        streetAddressLine2: [{ max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        city: [{ required: true, message: 'City is Required', trigger: 'blur' }, { max: 100, trigger: 'blur', message: 'Please Enter No More Than 100 Characters' }],
        province: [{ required: false, message: 'Province is Required', trigger: 'blur' }, { max: 100, trigger: 'change', message: 'Please Enter No More Than 100 Characters' }],
        vatCode: [{ max: 20, message: 'Please Enter No More Than 20 Characters', trigger: 'blur' }],
        vaiosstCode: [{ max: 20, message: 'Please Enter No More Than 20 Characters', trigger: 'blur' }],
        countryCode: [{ required: true, message: 'Country is Required', trigger: 'blur' }],
        zipCode: [{ required: true, message: 'Zip is Required', trigger: 'blur' }, { max: 20, message: 'Please Enter No More Than 20 Characters' }, { validator: this.checkisValidPostalCode, trigger: 'blur' }]
      },
      EUCountry: ['AT', 'BE', 'BG', 'CY', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', ' MT', 'NL', 'PL', ' PT', 'RO', 'SK', 'SI', 'ES', 'SE'],
      addressData: [],
      addressDataFilter: [],

      isAdd: false
    }
  },
  computed: {
    dialogTitle() {
      if (this.addressForm.type === 0) {
        return this.addressForm.id ? this.$t('address.editShippingAddress') : this.$t('address.addShippingAddress')
      } else if (this.addressForm.type === 1) {
        return this.addressForm.id ? this.$t('address.editBillingAddress') : this.$t('address.addBillingAddress')
      } else {
        return this.addressForm.id ? this.$t('address.editTheAddress') : this.$t('address.addAddress')
      }
    }
  },
  created() {
    this.areanolist = areanolist
    this.getAddressInfo()
    // this.addressForm = { ...this.addForm }
    this.getRegios(this.addForm.countryCode)
  },
  watch: {
    'addressForm.zipCode'(value) {
      if (value) {
        this.addressForm.zipCode = value.toLocaleUpperCase()
      }
    },
    dialogVisible(value) {
      if (value) {
        this.getRegios(this.addForm.countryCode)
        if (this.isAdd) {
          this.addressForm = {
            fullName: undefined,
            phoneNumber: undefined,
            streetAddressLine1: undefined,
            streetAddressLine2: undefined,
            city: undefined,
            province: undefined,
            countryCode: undefined,
            zipCode: undefined,
            vatCode: undefined,
            type: this.addForm.type
          }
        } else {
          this.addressForm = { ...this.addForm }
        }
        // this.addressForm = { ...this.addForm }
        this.addressForm.areaCode = this.addForm.areaCode || '+1'
        this.addressForm.countryCode = this.addForm.countryCode || 'US'
        // 订单处使用不必获取
        if (this.isOrderAddress) return
        this.getAddressInfo()
      }
    }
  },
  methods: {
    handleAreaCodeChange(value) {
      if (value && value.includes('+')) {
        let area = value.split('+')
        this.$set(this.addressForm, 'areaCode', area[1])
        this.$set(this.addressForm, 'countryCode', area[0])
      }
      this.$forceUpdate()
    },
    checkisValidPostalCode(rules, value, callback) {
      if (isValidPostalCode(value, this.addressForm.countryCode)) {
        callback()
      } else {
        callback(new Error('Please enter your valid zipcode'))
      }
    },
    getAddressInfo() {
      API.systemAddressInfo().then(res => {
        this.addressData = res.data
        this.addressDataFilter = this.addressData.slice()
      }).catch(result => {
        this.$message.error(result.data.message)
      })
    },
    handleCountryChange(value) {
      if (this.addressForm.countryCode) {
        this.$set(this.addressForm, 'province', undefined)
      }
      this.getRegios(value)
      if (this.EUCountry.indexOf(value) === -1) {
        this.$refs.addressForm.clearValidate()
      }
      const that = this
      setTimeout(() => {
        that.countryFilterMethod('')
      }, 500)
    },
    getRegios(value) {
      if (!value) return
      this.addressData.forEach(item => {
        if (item.code === value) {
          this.regions = item.childrens
          this.hasProvice = this.regions.length !== 0
        }
        // 同时切换国家编码
        if (item.countryCode === value) {
          this.$set(this.addressForm, 'areaCode', item.areaCode)
          this.$set(this.$data, 'areaCode', item.countryCode + item.areaCode)
        }
      })
    },
    show(showValid, isAdd) {
      this.isAdd = isAdd
      if (isAdd) {
        this.addressForm = {
          areaCode: '+1',
          fullName: undefined,
          phoneNumber: undefined,
          streetAddressLine1: undefined,
          streetAddressLine2: undefined,
          city: undefined,
          province: undefined,
          countryCode: undefined,
          zipCode: undefined,
          vatCode: undefined,
          type: this.addForm.type

        }
        this.areaCode = 'US+1'
      } else {
        this.addressForm = { ...this.addForm }
      }
      this.dialogVisible = true
      if (showValid) {
        this.$nextTick(() => {
          this.$refs.addressForm.validate()
        })
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    editAddress() {
      this.addressForm.userId = this.$store.state.common.userId
      this.$refs.addressForm.validate(valid => {
        if (!valid) return
        if (!this.addressForm.areaCode) { return this.$message.error(this.$t('promptText.msg22')) }
        if (!this.addressForm.id) { this.addressForm.id = null }
        this.loading = true
        if (!this.$store.state.common.userId) {
          this.$emit('submitForm', this.addressForm)
          return
        }
        // 在订单处更改地址，更改的是当前订单信息，与用户地址列表不同
        if (this.isOrderAddress) {
          this.loading = false
          this.dialogVisible = false
          this.$emit('orderAddressChange', this.addressForm)
          return
        }
        API.editAddress(this.addressForm).then(res => {
          this.dialogVisible = false
          this.$message.success(this.$t('promptText.msg23'))
          this.resetForm()
          this.$emit('submitForm')
          this.loading = false
        }).catch(result => {
          this.$message.error(result.data.message)
        }).finally(() => {
          this.loading = false
        })
      })
    },
    resetForm() {
      this.$emit('resetIsPayoneerError')
      this.$refs.addressForm.resetFields()
      this.addressForm = {}
    },
    countryFilterMethod(searchValue) {
      if (!searchValue) {
        this.addressDataFilter = this.addressData.slice()
      } else {
        const codeArr = []
        const nameArr = []
        this.addressData.forEach(e => {
          if (e.countryCode.includes(searchValue.toUpperCase())) {
            codeArr.push(e)
          } else if (e.countryNameEn.toUpperCase().includes(searchValue.toUpperCase())) {
            nameArr.push(e)
          } else if (searchValue.toUpperCase() === 'UK' && e.countryNameEn.toUpperCase().includes('ENGLAND')) {
            nameArr.push(e)
          }
        })
        this.addressDataFilter = [...codeArr, ...nameArr]
      }
    }
  }
}
</script>
<style lang="scss">
.el-input__inner {
  &::placeholder {
    font-family: Arial;
    // color: #10141D;
  }
}
/* 移动端样式 */
@media screen and (max-width: 1000px) {
  .address-dialog .el-dialog__body{
    overflow-y: auto;
    padding: 0 15px;
  }
  .mobile-address-form .el-form-item__label{
    padding: 0;
  }
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    color: transparent;
  }
}
</style>
<style lang="scss" scoped>
/deep/.el-input-group__prepend {
  color: #606266;
}
/deep/.el-input-group__prepend {
  background-color: #fff;
  border-radius: 18px 0 0 18px;
  width: 80px;
}
/* pc端样式 */
@media screen and (min-width: 1000px) {
  /deep/.el-input__inner {
    height: 36px;
    border-radius: 18px;
  }
  /deep/.el-input-group--prepend .el-input__inner {
    border-radius: 0 18px 18px 0;
  }
  /deep/.el-row .el-form-item {
    margin-bottom: 16px;
  }
  /deep/.el-form .el-form-item {
    margin-bottom: 10px;
  }
  /deep/.el-form-item__error {
    padding-left: 15px;
    margin-bottom: 5px;
  }
  /deep/.is-error {
    height: 80px;
  }
  /deep/.el-form-item .el-form-item__label {
    margin-bottom: 5px;
    line-height: 30px;
    padding: 0;
  }
  /deep/.el-dialog__body {
    height: 52vh;
    overflow: auto;
  }
  /deep/.el-button--success {
    border-color: none;
    border: none;
    background: #99c41c;
  }
}
/** 移动端弹窗 */
.address-dialog-moblie {
  overflow: hidden;
  /deep/ .el-dialog__body {
    max-height: calc(100% - 130px);
  }
  /deep/ .el-dialog__footer {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}
</style>
